'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { IconName } from '@qogita/svg-icons'
import { ComponentProps, ReactNode } from 'react'

import { cn } from '../../utils/cn'
import { Tooltip } from './_tooltip/_tooltip'
import { BaseButton, useButtonContext } from './base-button'
import { Icon } from './icon'
import { LayeredStack } from './layered-stack'
import { LoadingIcon } from './loading-icon'

type IconButtonCoreProps = Omit<
  ComponentProps<typeof BaseButton>,
  'aria-label' | 'children'
> & {
  iconName: IconName
  label: string
  size: 'sm'
}

/**
 * Renders a loading spinner whenever the IconButton's `isLoadingOverride` prop is true,
 * or when the button is a submit button and the form is loading.
 * The icon is hidden while the spinner is visible.
 */
function IconButtonLoader({ children }: { children?: ReactNode }) {
  const { isLoading } = useButtonContext()
  return (
    <LayeredStack>
      <span
        className={cn(
          'transition-opacity',
          isLoading ? 'opacity-0' : 'opacity-100',
        )}
      >
        {children}
      </span>
      <LoadingIcon
        aria-hidden
        className={cn(
          'size-4.5 transition-opacity',
          isLoading ? 'opacity-100' : 'opacity-0',
        )}
      />
    </LayeredStack>
  )
}

/**
 * Icon-only button without a tooltip.
 *
 * Internal building block for {@link IconButton} and components such as
 * CopyButton that need custom tooltip behaviour — for example dynamic help text
 * or controlled open state for transient feedback — without widening the
 * public IconButton API.
 */
export function IconButtonCore({
  iconName,
  label,
  className,
  size,
  ...props
}: IconButtonCoreProps) {
  return (
    <BaseButton
      aria-label={label}
      className={cn(
        'inline-grid place-content-center rounded-sm hover:opacity-75 aria-disabled:opacity-40',
        {
          'size-6': size === 'sm',
        },
        className,
      )}
      {...props}
    >
      <IconButtonLoader>
        <Icon
          name={iconName}
          className={cn({
            'size-4.5': size === 'sm',
          })}
        />
      </IconButtonLoader>
    </BaseButton>
  )
}

export function IconButton({
  iconName,
  label,
  rumTooltipName,
  className,
  size,
  ...props
}: IconButtonCoreProps & { rumTooltipName?: string }) {
  return (
    <Tooltip help={label} rumTooltipName={rumTooltipName}>
      <IconButtonCore
        iconName={iconName}
        label={label}
        className={className}
        size={size}
        {...props}
      />
    </Tooltip>
  )
}
